import logo from './logo.svg';
import './App.css';
import { Transition, TransitionGroup } from 'react-transition-group';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Redirect,
  useLocation,
  useParams
} from "react-router-dom";

/* Pages */
import Homepage from './components/Homepage';
import AboutPage from './components/PageAbout';
import ContactPage from './components/PageContact';
import StoryPage from './components/PageStory';
import MobileMenu from './components/MobileMenu';
import SeriesOne from './components/PageSeriesOne';
import Landing from './components/Landing';



function App() {

  return (
    <Router>
      <div className="App">
        <div class='bgNoise'></div>
        <div className='appContainer'>
          <header className="App-header">
            <LogoSpace />
            <MobileMenu />
          </header>
          <div className='appRouter'>
            <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="/landing" element={<Landing />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/series/one" element={<SeriesOne />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/from-the-editors" element={<StoryPage />} />
            </Routes>
          </div>
        </div>
      </div>
    </Router>
  );
}

function LogoSpace() {
  const location = useLocation();
  return (
    <div className='hanumanLogo'>
      <Link to={`${location.pathname == '/' ? '/about' : ''}`}>Hanuman<br />Editions</Link>
    </div>
  )
}

export default App;

